export default "__VITE_ASSET__B02RG4U2__"